<template>
  <div class="hello">
    <!-- ******PROMO****** -->
    <section id="promo" class="promo section offset-header has-pattern">
        <div class="container">
            <div class="row row-centered">
                <div class="overview col-md-12 col-sm-12 col-xs-12 col-centered">
		        <h1 class="big">Pandaaz</h1>
                    <h2 class="title">Innover pour un changement positif</h2>
                    <ul class="summary list-inline title" >
			            <li>Innovation</li>
                        <li>Altruisme</li>
                        <li>Respect</li>
                    </ul>
                </div><!--//overview-->
            </div><!--//row-->
        </div><!--//container-->
    </section><!--//promo-->
    <!-- ******FEATURES****** -->
    <section id="about" class="features section">
        <div class="container">
            <div class="row feature-row-last">
                <div class="item col-md-4 col-sm-6 col-xs-12 text-center">
                    <div class="icon">
                        <i class="fa fa-gears"></i>            
                    </div><!--//icon-->
                    <div class="content">
                        <h3 class="title">La Génèse</h3>
                        <p><b>Pandaaz</b> est une jeune startup née d'un désir de vouloir proposer des solutions innovantes sur des problèmes du quotidien.
			 <br><br>Ainsi au fil du temps, l'idée a fini par s'imposer : mutualiser des forces afin de bâtir quelque chose et ce quelque chose serait porteur de différents projets en les exécutant successivement.
			  <br><br><b class="yaawi-purple">Ainsi naquît Pandaaz...</b>
			</p>
                    </div><!--//content-->
                </div><!--//item-->
                <div class="item col-md-4 col-sm-6 col-xs-12 text-center">
                    <div class="icon">
                        <i class="fa fa-globe"></i>      
                    </div><!--//icon-->
                    <div class="content">
                        <h3 class="title">Un But</h3>
                        <p>Proposer des solutions à des problèmes du quotidien, au travers d’applications mobiles et/ou services internet dans des domaines ou secteurs où ils peuvent avoir une vraie valeur ajoutée.<br><br>
			L’ensemble piloté par une <b>approche innovante</b> et avec pour principale motivation de satisfaire ses clients au travers de produits de qualité.
			</p>
                    </div><!--//content-->
                </div><!--//item-->
                <div class="item col-md-4 col-sm-12 col-xs-12 text-center">
                    <div class="icon">
                        <i class="fa fa-eye"></i>
                    </div><!--//icon-->
                    <div class="content">
                        <h3 class="title">Une Vision</h3>
                        <p>Initier une belle aventure en s’entourant de talents prêts à les rejoindre, dans ce qui s’annonce comme étant quelque chose de passionnant et enrichissant.<br>
			Car au delà de l’aspect entrepreneurial et de l’intérêt technologique, il s’agit avant tout de prendre du plaisir et de se retrouver autour des valeurs arborées  au sein de Pandaaz :
			<br><b class="yaawi-purple">Innovation</b>, <b>Respect</b>, <b class="yaawi-blue">Altruisme</b>. <br>Ces valeurs constituant la fondation sur laquelle est bâtie <b>Pandaaz</b> et qui vient renforcer son ADN qui se trouve résumé dans notre mantra :
			<br><br><b class="yaawi-purple">« Innover pour un changement positif »</b>.
			</p>
                    </div><!--//content-->           
                </div><!--//item-->
            </div><!--//row-->
        </div><!--//container-->
    </section><!--//features-->
    <!-- ******HOW****** -->
    <section id="project" class="faq section has-pattern">
        <div class="container">
            <div class="row">
                <h2 class="title text-center">Projets</h2>
                <div class="faq-col col-md-4 col-sm-6 col-xs-12">
                    <div class="item">
                        <h3 class="question"><i class="fa fa-question-circle"></i>RminMe</h3>
                        <p class="answer">Qui n'a jamais pesté contre le fait de ne plus savoir à qui il avait bien pu prêter tel ou tel objet.Que ce soit en groupe ou de manière individuelle, RminMe vous propose une nouvelle manière d'appréhender les actions de prêts et d'emprunts.
                        Les usages sont multiples, la seule limite étant votre imagination, chacun devrait y trouver son compte, professionel ou particulier.
                        <br><br>Ainsi que vous soyez une association, un groupe d'amis, ou même au sein des services d'une société, vous n'aurez plus à demander pour retrouver cette info, elle sera présente au sein de <a href="https://www.rmin.me" target="_blank"><b>RminMe</b></a>.. <br><br>
                        Disponible également sur <a href="https://itunes.apple.com/fr/app/rminme/id892578369?l=fr&ls=1&mt=8" target="_blank">IOS</a> & <a href="https://play.google.com/store/apps/details?id=io.gonative.android.rdeyl" target="_blank">Android</a>.
			</p>
                    </div><!--//item-->
                </div><!--//faq-col-->
                <div class="faq-col col-md-4 col-sm-6 col-xs-12">
                    <div class="item">
                        <h3 class="question"><i class="fa fa-question-circle"></i>Chaperon</h3>
                        <p class="answer">Il s’agit là de notre dernier né, ce projet dont le nom de code fut « C » offrira une nouvelle approche dans le domaine de la rencontre.<br><br>
			  A l’heure actuelle une version BETA de l’application est disponible mais en mode privé, les feedbacks reçus dénotent un réel engouement pour le projet. <br><br>
			  Nous avons des partenariats déjà établis et d’autres sont en cours.<br><br>D’ailleurs si vous souhaitez faire partie de la bêta privée, rendez-vous sur le site de <a href="https://www.chaperon.me" target="_blank"><b>Chaperon</b></a>
			  dans lequel vous avez la possibilité de laisser votre adresse email. Ainsi vous pourrez être informés et recevoir votre invitation pour participer.
			  <br><br>Plus de détails viendront agrémenter cette description, donc soyez à l’écoute…
			</p>
                    </div><!--//item-->
                </div><!--//faq-col-->
                <div class="faq-col col-md-4 col-sm-6 col-xs-12">
                    <div class="item">
                        <h3 class="question"><i class="fa fa-question-circle"></i>D'autres à venir...</h3>
                        <p class="answer">A SUIVRE....<br><br>RESTEZ CONNECTES</p>
                    </div><!--//item-->
                </div><!--//faq-col-->
            </div><!--//row--><!--
            <div class="more text-center">
                <h4 class="title">D'autres questions?</h4>
                <a class="btn btn-lg btn-theme scrollto"  href="#contact">Restons en contact<i class="fa fa-arrow-circle-o-down"></i></a>
	    </div>-->
        </div><!--//container-->
    </section><!--//how-->
    <!-- ******STORY****** --> 
    <!--
    <section id="story" class="story section has-pattern">
        <div class="container">
	    <div class="row">
	      <div class="content col-md-12 col-sm-12 col-xs-12 text-center">
		<h2 class="title">L'équipe fondatrice</h2>
	      </div>
	    </div>
	    <div class="row">
        <div class="col-md-3">&nbsp;</div>
	      <div class="col-md-6">
		<div class="row team">
		    <div class="member col-md-4 col-sm-6 text-center">
			<img class="img-rounded circular-image" src="static/img/team/member-1.png" alt="" />
            <img class="img-rounded circular-image" src="assets/logo.png" alt="" />
			<p class="name">William Achiepo</p>
			<p class="title">France</p>
			<ul class="connect list-inline">
			    <li><a href="https://fr.linkedin.com/in/william-achiepo-1718ba3" target="_blank"><i class="fa fa-linkedin"></i></a></li>
			</ul>
		    </div><!--//member--><!--
		    <div class="col-md-8 col-sm-6">
		      <ul class="fa-ul">
			<li><i class="fa-li fa fa-briefcase"></i>15 ans d’expérience  dans le Web et les nouvelles technologies</li>
		      </ul>
		      <ul class="fa-ul">
			<li><i class="fa-li fa fa-lightbulb-o"></i>Kayboo, Reevive.me</li>
		      </ul>
		      <ul class="fa-ul">
			<li><i class="fa-li fa fa-industry"></i>A fondé @W2 Consulting <br>A fondé Kayboo</li>
		      </ul>
		      <ul class="fa-ul">
			<li><i class="fa-li fa fa-tag"></i>#Entrepreneur, #Passionné, #Dynamique, #Motivé, #Créatif, #Geek, #Zen</li>
		      </ul>
		    </div>
		</div><!--//row--><!--
		<div class="row">
		  <div class="col-md-12">
		    <p>
		      Il a une forte expérience dans le Web et les nouvelles technologies, il y travaille depuis près de 15 ans et conjugue ses activités au pluriel en officiant aussi en tant que freelance autour de SAP. Activité pour laquelle il intervient dans la mise en place de projets Webs pour des grands comptes du CAC 40.
		      <br><br>Cette activité lui a permis de se créer un solide réseau, de faire évoluer son expertise, d’améliorer son sens du relationnel, du management, de la gestion et aussi de faire de belles rencontres. <br><br>Et de l’autre côté sa fibre entrepreneuriale et son envie de créer de nouveaux outils qui ont pu s’exprimer grâce à sa 1ere activité, ce qui lui donné l’opportunité de monter une autre structure : « Kayboo ».
		      Kayboo est à l’origine le nom de son 1er projet : une plateforme de mise en relation entre sociétés et indépendants du secteur IT, d'autres projets ont suivis et comme il aime à le répéter, il n'a pas l'intention de s'arrêter.
		    </p>
		  </div>
		</div>
		<div class="row">
		  <div class="col-md-12">
		    &nbsp;
		  </div>
		</div>
	      </div><!--col1--><!--
	      <div class="col-md-6">
		<div class="row">
		  <div class="col-md-12">
		    &nbsp;
		  </div>
		</div>
	      </div><!--col2--><!--
	    </div>
        </div><!--//container--><!--
    </section><!--//story-->
   
    <!-- ******CONTACT****** --> 
    <section id="contact" class="contact section has-pattern">
        <div class="container">
            <div class="row text-center">
                <h2 class="title">Nous contacter</h2>
                <div class="intro col-md-6 col-sm-12 col-xs-12 col-md-offset-3">
                    <p>Vous avez des questions, ou des commentaires ? Vous avez envie de vous impliquer dans un projet ambiteux, en tant qu'<b class="yaawi-purple">investisseurs</b> ou <b class="yaawi-blue">potentiels partenaires</b>? <br><br>Ou vous avez été séduit par ce projet et voulez aussi participer à cette aventure en rejoignant une équipe motivée et dynamique</p>
		    <br><br>
		    <p>PAS UNE MINUTE A PERDRE, NOUS SERIONS RAVIS D'ECHANGER...</p>
                    <ul class="list-unstyled contact-details">
                        <li><i class="fa fa-envelope"></i><a href="mailto:hello@pandaaz.com">hello@pandaaz.com</a></li>
                        <!--<li><i class="fa fa-phone-square"></i>0800 123 456</li>-->
                    </ul>
                </div>
            </div><!--//row-->
        </div><!--//container-->
    </section><!--//contact-->
    <!-- ******FOOTER****** -->
    <footer class="footer">
        <div class="container">
            <small class="copyright pull-left">Copyright &copy; 2018 <b>Pandaaz</b></small><!--
            <ul class="links list-inline">
                <li><a href="#">Terms</a></li>
                <li><a href="#">Privacy</a></li>
            </ul>-->
        </div>
    </footer><!--//footer-->
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue